import ApiService from './api.service'

const TransportService = {    
    get(projectId, companyId, companyName, addressSearchString, idType, technologyId, serialNumber, meterSerialNumber, isDeleted, sortColumns, page, count) {
      return ApiService.get('api/transports', {
        params: {
          ProjectId: projectId,
          CompanyId: companyId,
          CompanyName: companyName,
          AddressSearchString: addressSearchString,
          TypeId: idType,
          TechnologyId: technologyId,
          SerialNumber: serialNumber,
          MeterSerialNumber: meterSerialNumber,
          IsDeleted: isDeleted,
          SortColumns: sortColumns,
          Page: page,
          Count: count
        }
      })
    },

    getSettings(id) {
      return ApiService.get('/api/transports/settings', {
        params: {
          id: id
        }
      })
    },

    getFreeChannels(idCompany, idMeterType, serialNumber, page, count) {
      return ApiService.get('api/transports/free-channels', {
        params: {
          IdCompany: idCompany,
          IdMeterType: idMeterType,
          SerialNumber: serialNumber,
          Page: page,
          Count: count
        }
      })
    },

    getById(id) {
      return ApiService.get('api/transports/'+id)
    },

    create(idCompany, serialNumber, integratedMeterSerialNumber, idType, imei, idSimCard, echoSuppression, additionalInfo) {
      let transport = {
        idCompany: idCompany,
        serialNumber: serialNumber,
        integratedMeterSerialNumber: integratedMeterSerialNumber,
        idType: idType,
        imei: imei,
        idSimCard: idSimCard,
        echoSuppression: echoSuppression,
        additionalInfo: additionalInfo
      }
      return ApiService.post(`/api/transports`, transport)
    },

    clone(id, idCompany) {
      let transport = {
        id: id,
        idCompany: idCompany
      }
      return ApiService.post(`/api/transports/clone`, transport)
    },

    update(id, serialNumber, integratedMeterSerialNumber, idType, imei, idSimCard, echoSuppression, additionalInfo) {
      let transport = {
        id: id,
        serialNumber: serialNumber,
        integratedMeterSerialNumber: integratedMeterSerialNumber,
        idType: idType,
        imei: imei,
        idSimCard: idSimCard,
        echoSuppression: echoSuppression,
        additionalInfo: additionalInfo
      }
      return ApiService.put(`/api/transports`, transport)
    },

    updateSettings(id, settingsNumber, settings) {
      let transport = {
        id: id,
        settingsNumber: settingsNumber,
        settings: settings,        
      }
      return ApiService.put(`/api/transports/settings`, transport)
    },

    updateSettingsGroup(idProject, publicCode, settingsNumber, settings) {
      let transport = {
        idProject: idProject,
        publicCode: publicCode,
        settingsNumber: settingsNumber,
        settings: settings,        
      }
      return ApiService.put(`/api/transports/settings-group`, transport)
    },

    archive(id) {
      return ApiService.put(`/api/transports/archive/${id}`)
    },

    restore(id) {
      return ApiService.put(`/api/transports/restore/${id}`)
    },

    delete(id) {
      return ApiService.delete(`/api/transports/${id}`)
    },

    getConnectionStatistics(gatewaySerialNumber, transportId, transportSerialNumber, periodFrom, periodTo, groupByDate, page, count) {
      return ApiService.get('/api/transports/connection-statistics', {
        params: {
          GatewaySerialNumber: gatewaySerialNumber,
          TransportId: transportId,
          TransportSerialNumber: transportSerialNumber,
          PeriodFrom: periodFrom,
          PeriodTo: periodTo,
          GroupByDate: groupByDate,
          Page: page,
          Count: count
        }
      })
    },

    createType(idTransportTechnology, tradeMark, name, publicCode, countDiscreteInputs, countDiscreteOutputs, countAnalogsInputs, countAnalogOutputs, countRs232Interfaces, hasRssi, hasLqi, hasSnr) {
      let transportType = {
        idTransportTechnology: idTransportTechnology,
        tradeMark: tradeMark,
        name: name,
        publicCode: publicCode,
        countDiscreteInputs: countDiscreteInputs,
        countDiscreteOutputs: countDiscreteOutputs,
        countAnalogsInputs: countAnalogsInputs,
        countAnalogOutputs: countAnalogOutputs,
        countRs232Interfaces: countRs232Interfaces,
        hasRssi: hasRssi,
        hasLqi: hasLqi,
        hasSnr: hasSnr,
      }
      return ApiService.post(`/api/transports/types`, transportType)
    },

    updateType(id, idTransportTechnology, tradeMark, name, countDiscreteInputs, countDiscreteOutputs, countAnalogsInputs, countAnalogOutputs, countRs232Interfaces, hasRssi, hasLqi, hasSnr) {
      let transportType = {
        id: id,
        idTransportTechnology: idTransportTechnology,
        tradeMark: tradeMark,
        name: name,
        countDiscreteInputs: countDiscreteInputs,
        countDiscreteOutputs: countDiscreteOutputs,
        countAnalogsInputs: countAnalogsInputs,
        countAnalogOutputs: countAnalogOutputs,
        countRs232Interfaces: countRs232Interfaces,
        hasRssi: hasRssi,
        hasLqi: hasLqi,
        hasSnr: hasSnr,
      }
      return ApiService.put(`/api/transports/types`, transportType)
    },

    deleteType(id) {
      return ApiService.delete(`/api/transports/types/${id}`)
    },

    getTypes(id, idTransportTechnology, name, tradeMark) {
      return ApiService.get('api/transports/types', {
        params: {
          Id: id,
          IdTransportTechnology: idTransportTechnology,
          Name: name,
          TradeMark: tradeMark
        }
      })
    },

    getTechnologies(id) {
      return ApiService.get('api/transports/technologies', {
        params: {
          Id: id,
        }
      })
    }
}

export default TransportService